package meineglasfaser.frontend.admin.components.layouts

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.layout.Layout
import org.jetbrains.compose.web.dom.Main

@Layout
@Composable
fun AdminAuthLayout(content: @Composable () -> Unit) {
    Main(attrs = { classes("auth-main") }) {
        content()
    }
}
